import { render, staticRenderFns } from "./SmsTemplate.vue?vue&type=template&id=38d8bbb6&scoped=true&"
import script from "./SmsTemplate.vue?vue&type=script&lang=js&"
export * from "./SmsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d8bbb6",
  null
  
)

export default component.exports